import { FC, useState } from "react";
import { Box, Typography } from "@mui/material";

import CustomModal from "../../../common/custom-modal/custom-modal";
import { CustomButton } from "../../../atoms";
import { pxToRem } from "../../../../util";
import { Colors } from "../../../../configs";

interface ISpecificationModalProps {
  open: boolean;
  onClose: () => void;
}

const SpecificationModal: FC<ISpecificationModalProps> = ({
  open,
  onClose,
}) => {
  const [activeTab, setActiveTab] = useState<1 | 2>(1);

  return (
    <CustomModal
      title="Specifications"
      openModal={open}
      onClose={onClose}
      width={pxToRem(564)}
      height={pxToRem(420)}
    >
      <Box sx={{ display: "flex", gap: 0, mb: pxToRem(10) }}>
        <Box
          onClick={() => setActiveTab(1)}
          sx={{
            width: pxToRem(104),
            height: pxToRem(31),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor:
              activeTab === 1 ? Colors.PRIMARY : Colors.BACKSHADE_GRAY,
            color: activeTab === 1 ? Colors.WHITE : Colors.PRIMARY,
            fontSize: pxToRem(14),
            fontWeight: 500,
            cursor: "pointer",
            borderTopLeftRadius: "0.71rem",
          }}
        >
          Dimensions
        </Box>

        <Box
          onClick={() => setActiveTab(2)}
          sx={{
            width: pxToRem(104),
            height: pxToRem(31),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor:
              activeTab === 2 ? Colors.PRIMARY : Colors.BACKSHADE_GRAY,
            color: activeTab === 2 ? Colors.WHITE : Colors.PRIMARY,
            fontSize: pxToRem(14),
            fontWeight: 500,
            cursor: "pointer",
            borderTopRightRadius: "0.71rem",
          }}
        >
          Weight
        </Box>
      </Box>

      <Box
        sx={{
          width: pxToRem(462),
          height: pxToRem(3),
          backgroundColor: Colors.BACKSHADE_GRAY,
          mb: pxToRem(24),
          mt: pxToRem(-12),
        }}
      />

      <Box sx={{ minHeight: pxToRem(150), mt: pxToRem(30) }}>
        {activeTab === 1 && (
          <Box
            sx={{ display: "flex", flexDirection: "column", gap: pxToRem(25) }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: pxToRem(25) }}
            >
              <Typography
                sx={{
                  fontSize: pxToRem(20),
                  color: Colors.MAIN_GRAY,
                  minWidth: pxToRem(60),
                }}
              >
                Units
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: pxToRem(166),
                  height: pxToRem(39),
                  borderRadius: "0.71rem",
                  border: `1px solid ${Colors.ACCENT_GRAY_DISABLED}`,
                  backgroundColor: Colors.WHITE,
                  ml: pxToRem(20),
                }}
              >
                <input
                  type="number"
                  autoComplete="off"
                  placeholder="Length"
                  style={{
                    width: pxToRem(104),
                    height: "100%",
                    border: "none",
                    outline: "none",
                    paddingLeft: pxToRem(8),
                    fontSize: pxToRem(20),
                    color: Colors.MAIN_GRAY,
                    backgroundColor: "transparent",
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                  }}
                />
                <Box
                  sx={{
                    width: "1px",
                    height: pxToRem(39),
                    backgroundColor: Colors.ACCENT_GRAY_DISABLED,
                  }}
                />
                <Box
                  sx={{
                    position: "relative",
                    width: pxToRem(61),
                    height: "100%",
                  }}
                >
                  <select
                    defaultValue="inch"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: pxToRem(14),
                      color: Colors.MAIN_GRAY,
                      backgroundColor: "transparent",
                      paddingLeft: pxToRem(4),
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                    }}
                  >
                    <option value="inch">inch</option>
                    <option value="cm">cm</option>
                  </select>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: pxToRem(6),
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      fontSize: pxToRem(12),
                      color: Colors.MAIN_GRAY,
                    }}
                  >
                    ▼
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: pxToRem(166),
                  height: pxToRem(39),
                  borderRadius: "0.71rem",
                  border: `1px solid ${Colors.ACCENT_GRAY_DISABLED}`,
                  backgroundColor: Colors.WHITE,
                }}
              >
                <input
                  type="number"
                  autoComplete="off"
                  placeholder="Width"
                  style={{
                    width: pxToRem(104),
                    height: "100%",
                    border: "none",
                    outline: "none",
                    paddingLeft: pxToRem(8),
                    fontSize: pxToRem(20),
                    color: Colors.MAIN_GRAY,
                    backgroundColor: "transparent",
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                  }}
                />
                <Box
                  sx={{
                    width: "1px",
                    height: pxToRem(39),
                    backgroundColor: Colors.ACCENT_GRAY_DISABLED,
                  }}
                />
                <Box
                  sx={{
                    position: "relative",
                    width: pxToRem(61),
                    height: "100%",
                  }}
                >
                  <select
                    defaultValue="inch"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: pxToRem(14),
                      color: Colors.MAIN_GRAY,
                      backgroundColor: "transparent",
                      paddingLeft: pxToRem(4),
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                    }}
                  >
                    <option value="inch">Inch</option>
                    <option value="cm">Cm</option>
                  </select>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: pxToRem(6),
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      fontSize: pxToRem(12),
                      color: Colors.MAIN_GRAY,
                    }}
                  >
                    ▼
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{ display: "flex", flexDirection: "column", gap: pxToRem(4) }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: pxToRem(20) }}
              >
                <Typography
                  sx={{
                    fontSize: pxToRem(20),
                    color: Colors.MAIN_GRAY,
                    minWidth: pxToRem(60),
                  }}
                >
                  Price
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: pxToRem(360),
                    height: pxToRem(39),
                    borderRadius: "0.71rem",
                    border: `1px solid ${Colors.ACCENT_GRAY_DISABLED}`,
                    backgroundColor: Colors.WHITE,
                    paddingLeft: pxToRem(8),
                    fontSize: pxToRem(20),
                    color: Colors.MAIN_GRAY,
                    ml: pxToRem(25),
                  }}
                >
                  $
                  <input
                    type="number"
                    autoComplete="off"
                    style={{
                      flex: 1,
                      height: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: pxToRem(20),
                      color: Colors.MAIN_GRAY,
                      backgroundColor: "transparent",
                      paddingLeft: pxToRem(4),
                      WebkitAppearance: "none",
                      MozAppearance: "textfield",
                    }}
                  />
                </Box>
              </Box>

              <Typography
                sx={{
                  fontSize: pxToRem(14),
                  color: Colors.MAIN_GRAY,
                  textAlign: "right",
                }}
              >
                61.58 SqFt * $2.58 / SqFt
              </Typography>
            </Box>
          </Box>
        )}

        {activeTab === 2 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: pxToRem(25),
              mt: pxToRem(30),
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: pxToRem(20) }}
            >
              <Typography
                sx={{
                  fontSize: pxToRem(20),
                  color: Colors.MAIN_GRAY,
                  minWidth: pxToRem(60),
                }}
              >
                Weight
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: pxToRem(360),
                  height: pxToRem(39),
                  borderRadius: "0.71rem",
                  border: `1px solid ${Colors.ACCENT_GRAY_DISABLED}`,
                  backgroundColor: Colors.WHITE,
                  ml: pxToRem(25),
                }}
              >
                <input
                  type="number"
                  autoComplete="off"
                  placeholder="Weight"
                  style={{
                    flex: 1,
                    height: "100%",
                    border: "none",
                    outline: "none",
                    fontSize: pxToRem(20),
                    color: Colors.MAIN_GRAY,
                    backgroundColor: "transparent",
                    paddingLeft: pxToRem(8),
                    WebkitAppearance: "none",
                    MozAppearance: "textfield",
                  }}
                />
                <Box
                  sx={{
                    width: "1px",
                    height: pxToRem(39),
                    backgroundColor: Colors.ACCENT_GRAY_DISABLED,
                  }}
                />
                <Box
                  sx={{
                    position: "relative",
                    width: pxToRem(61),
                    height: "100%",
                  }}
                >
                  <select
                    defaultValue="lb"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: pxToRem(14),
                      color: Colors.MAIN_GRAY,
                      backgroundColor: "transparent",
                      paddingLeft: pxToRem(4),
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                    }}
                  >
                    <option value="lb">lb</option>
                    <option value="g">g</option>
                    <option value="kg">kg</option>
                  </select>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: pxToRem(6),
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      fontSize: pxToRem(12),
                      color: Colors.MAIN_GRAY,
                    }}
                  >
                    ▼
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{ display: "flex", flexDirection: "column", gap: pxToRem(4) }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: pxToRem(20) }}
              >
                <Typography
                  sx={{
                    fontSize: pxToRem(20),
                    color: Colors.MAIN_GRAY,
                    minWidth: pxToRem(60),
                  }}
                >
                  Price
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: pxToRem(360),
                    height: pxToRem(39),
                    borderRadius: "0.71rem",
                    border: `1px solid ${Colors.ACCENT_GRAY_DISABLED}`,
                    backgroundColor: Colors.WHITE,
                    paddingLeft: pxToRem(8),
                    fontSize: pxToRem(20),
                    color: Colors.MAIN_GRAY,
                    ml: pxToRem(25),
                  }}
                >
                  $
                  <input
                    type="number"
                    autoComplete="off"
                    style={{
                      flex: 1,
                      height: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: pxToRem(20),
                      color: Colors.MAIN_GRAY,
                      backgroundColor: "transparent",
                      paddingLeft: pxToRem(4),
                      WebkitAppearance: "none",
                      MozAppearance: "textfield",
                    }}
                  />
                </Box>
              </Box>

              <Typography
                sx={{
                  fontSize: pxToRem(14),
                  color: Colors.MAIN_GRAY,
                  textAlign: "right",
                }}
              >
                61.58 lb * $2.58 / lb
              </Typography>
            </Box>
          </Box>
        )}
      </Box>

      <Box sx={{ mt: "auto", display: "flex", justifyContent: "center" }}>
        <CustomButton
          sx={{
            width: pxToRem(467),
            height: pxToRem(64),
            fontSize: pxToRem(24),
            fontWeight: "bold",
            borderRadius: "1.2rem",
            background: Colors.PRIMARY,
          }}
        >
          Add
        </CustomButton>
      </Box>
    </CustomModal>
  );
};

export default SpecificationModal;
